import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { RoseMark } from "@/components/RoseMark";
import { NavLinks, UserMenu, GuestLinks } from "@/components/header/NavParts";
import { MobileMenu } from "@/components/header/MobileMenu";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-paper/85 border-b border-stone-200/60 px-3 sm:px-8 py-3 flex items-center justify-between gap-2">
      <Link to="/" className="flex items-center gap-2 group shrink-0" data-testid="brand-link">
        <div className="w-11 h-11 rounded-2xl bg-[#fefaf4] ring-1 ring-stone-200 flex items-center justify-center shadow-sm group-hover:-rotate-3 transition-transform">
          <RoseMark className="w-9 h-9" />
        </div>
        <div className="hidden md:block">
          <div className="font-display text-lg font-extrabold tracking-tight text-[var(--brand-teal)] leading-none">Root <span className="text-[var(--brand-olive)]">&</span> Rose</div>
          <div className="text-[10px] uppercase tracking-widest text-[var(--brand-teal)]/70 mt-0.5">For tending your habit garden</div>
        </div>
      </Link>

      <div className="flex items-center gap-1 sm:gap-3 overflow-x-auto md:overflow-visible whitespace-nowrap min-w-0 [scrollbar-width:none]">
        {user ? (
          <>
            <div className="hidden md:flex items-center gap-3">
              <NavLinks user={user} />
              <UserMenu user={user} onLogout={handleLogout} />
            </div>
            <MobileMenu user={user} onLogout={handleLogout} />
          </>
        ) : (
          <GuestLinks />
        )}
      </div>
    </header>
  );
}
